import React from "react";
import Hero from "../components/Hero";

const Home = () => {
  return (
    <>
      <div className="bg-gray-800">
        <Hero />
      </div>
    </>
  );
};

export default Home;
